// extracted by mini-css-extract-plugin
export default {"steps":"liveqSteps_steps__xvwHD","stepsContent":"liveqSteps_stepsContent__LQ43d","stepsContentTitle":"liveqSteps_stepsContentTitle__mcoE3","buttonGap":"liveqSteps_buttonGap__fsstT"};